// extracted by mini-css-extract-plugin
module.exports = {"list":"style-module--list--2U77o","list__title":"style-module--list__title--2GzY3"};